<ev-page-header />
<main class="page">
  @switch (state().status) {
    @case ('loading') {
      <div class="page__status" role="status">
        <i aria-hidden="true" class="pi pi-spin pi-spinner page__spinner"></i>
        <span>{{ labels.loading }}</span>
      </div>
    }
    @case ('loaded') {
      @if (state(); as s) {
        @if (s.status === 'loaded') {
          <section class="page__plot">
            <span class="page__plot-label">{{ labels.plotHeading }}</span>
            <h1 class="page__plot-code">{{ s.page.plantation_code }}</h1>
            @if (s.page.plantation_name) {
              <span class="page__plot-name">{{ s.page.plantation_name }}</span>
            }
          </section>
          @if (s.page.failed_sources.length > 0) {
            <p class="page__notice" role="alert">{{ labels.partialNotice }}</p>
          }
          @if (s.files.length > 0) {
            <ev-evidence-table [items]="s.files" [token]="token()" />
          } @else {
            <p class="page__empty">{{ labels.empty }}</p>
          }
        }
      }
    }
    @case ('rate-limited') {
      <div class="page__status" role="alert">
        <span>{{ labels.rateLimited }}</span>
        <button class="page__retry" type="button" (click)="load()">
          {{ labels.retry }}
        </button>
      </div>
    }
    @default {
      <div class="page__status" role="alert">
        <span>{{ labels.loadError }}</span>
        <button class="page__retry" type="button" (click)="load()">
          {{ labels.retry }}
        </button>
      </div>
    }
  }
</main>
